import { Asterisk } from "lucide-react";

const ITEMS = [
  "Hemsidor",
  "Logotyp",
  "Grafisk design",
  "Menydesign",
  "Reklamblad & flyers",
  "Posters & affischer",
  "Google Företagsprofil",
  "Sociala medier",
  "Digital annonsering",
];

const Marquee = () => (
  <div aria-hidden="true" className="overflow-hidden border-y border-white/10 bg-navy2 py-5">
    <div className="animate-marquee flex w-max">
      {[...ITEMS, ...ITEMS].map((t, i) => (
        <span key={i} className="flex items-center">
          <span className="whitespace-nowrap font-display text-sm font-bold uppercase tracking-[0.28em] text-cream/50">
            {t}
          </span>
          <Asterisk size={18} className="mx-8 shrink-0 text-orange" />
        </span>
      ))}
    </div>
  </div>
);

export default Marquee;
